export default "__VITE_ASSET__B_f4fmE6__"